export const Marquee = ({ items, dark = false }) => {
  const row = [...items, ...items];
  return (
    <div
      className={`overflow-hidden border-y ${dark ? "border-white/10 bg-navy-deep" : "border-slate-200 bg-slate-50"}`}
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center py-4">
        {row.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className={`px-6 font-mono text-xs font-medium uppercase tracking-[0.28em] ${dark ? "text-teal-300/70" : "text-slate-500"}`}>
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-teal-500/70" />
          </span>
        ))}
      </div>
    </div>
  );
};
